<div id="login-page-content">
  @if (loginUiReady) {
  <div>
    <img id="relay-logo" src="/assets/relay-logo-full.png" alt="Relay logo" />
  </div>

  @if (authError === 'invitation_invalid') {
  <div id="login-form-and-help">
    <div id="login-form" class="auth-error">
      <p id="instructions" i18n="Expired invitation heading on login page">
        <b>This invitation link is no longer valid</b>
      </p>
      <p role="alert" i18n="Expired invitation message on login page">
        It may have expired or already been used. Please contact your Relay
        representative to request a new invitation.
      </p>
      <p i18n="Expired invitation sign-in hint on login page">
        If you have already set up your account, you can sign in instead.
      </p>
      <button type="button" class="submit-login btn" (click)="retryLogin()">
        <div class="submit-label" i18n="Label for go to sign in button">
          Go to sign in
        </div>
        <span class="icon icon-right">
          <i class="fa fa-arrow-right"></i>
        </span>
      </button>
    </div>
  </div>
  } @else if (authError === 'login_failed') {
  <div id="login-form-and-help">
    <div id="login-form" class="auth-error">
      <p id="instructions" i18n="Sign-in failure heading on login page">
        <b>We couldn't sign you in</b>
      </p>
      <p role="alert" i18n="Sign-in failure message on login page">
        Please try again. If the problem continues, contact your Relay
        representative.
      </p>
      <button type="button" class="submit-login btn" (click)="retryLogin()">
        <div class="submit-label" i18n="Label for try again button">
          Try again
        </div>
        <span class="icon icon-right">
          <i class="fa fa-arrow-right"></i>
        </span>
      </button>
    </div>
  </div>
  } @else if (sessionExpired) {
  <div id="login-form-and-help">
    <div id="login-form" class="auth-error">
      <p id="instructions" i18n="Session expired heading on login page">
        <b>Your session has ended</b>
      </p>
      <p role="status" i18n="Session expired message on login page">
        Please sign in again to continue.
      </p>
      <button
        type="button"
        id="session-expired-sign-in"
        class="submit-login btn"
        (click)="continueLogin()"
      >
        <div class="submit-label" i18n="Label for sign in again button">
          Sign in
        </div>
        <span class="icon icon-right">
          <i class="fa fa-arrow-right"></i>
        </span>
      </button>
    </div>
  </div>
  } @else if (serviceNotice) {
  <div id="login-form-and-help">
    <div id="login-form" class="auth-error service-notice">
      <p id="instructions">
        <b id="service-notice-title">{{ serviceNotice.title }}</b>
      </p>
      <p
        role="alert"
        id="service-notice-message"
        class="service-notice-message"
      >{{ serviceNotice.message }}</p>
      <button
        type="button"
        id="service-notice-continue"
        class="submit-login btn"
        [disabled]="continuingToSignIn"
        (click)="continueAfterNotice()"
      >
        <div class="submit-label" i18n="Label for continue to sign in button">
          Continue to sign in
        </div>
        <span class="icon icon-right">
          <i class="fa fa-arrow-right"></i>
        </span>
      </button>
    </div>
  </div>
  } @else if (!ssoScreen) {
  <div id="login-form-and-help">
    <form id="login-form">
      @if (!qrCode && !isTotp) {
      <p id="instructions" i18n="Password prompt on login page">
        Please enter your email address and password below
      </p>
      @if (error) {
      <p id="login-failure">
        <i class="fa fa-exclamation-circle"></i>
        <span class="login-failure-msg" i18n="Login failure message">{{
          error
        }}</span>
      </p>
      }
      <div
        class="input-with-icon"
        [ngClass]="{
                'has-error':
                  loginFormGroup.controls['email_address'].invalid &&
                  loginFormGroup.controls['email_address'].touched,
              }"
      >
        <input
          id="user-name-input"
          class="form-control"
          placeholder="Email Address"
          i18n-placeholder="Placeholder text for username field on login page"
          [formControl]="loginFormGroup.controls['email_address']"
          (keypress)="checkForEnter($event)"
        />
        <app-error-display
          [control]="loginFormGroup.controls['email_address']"
        ></app-error-display>
        <i class="fa fa-user"></i>
      </div>
      <div
        class="input-with-icon"
        [ngClass]="{
                'has-error':
                  loginFormGroup.controls['password'].invalid &&
                  loginFormGroup.controls['password'].touched,
              }"
      >
        <input
          id="password-input"
          type="password"
          class="form-control"
          placeholder="Password"
          i18n-placeholder="Placeholder text for password field on login page"
          [formControl]="loginFormGroup.controls['password']"
          (keypress)="checkForEnter($event)"
        />
        <app-error-display
          [control]="loginFormGroup.controls['password']"
        ></app-error-display>
        <i class="fa fa-lock"></i>
      </div>
      @if (!requestInFlight) {
      <button class="submit-login btn" (click)="attemptLogin()">
        <div
          class="submit-label"
          i18n="Label for submit login information button"
        >
          Submit
        </div>
        <span class="icon icon-right">
          <i class="fa fa-arrow-right"></i>
        </span>
      </button>
      }
      <br />
      <p class="generic-link" routerLink="/forgot-password">Reset Password</p>
      @if (requestInFlight) {
      <div class="login-spinner">
        <app-spinner></app-spinner>
      </div>
      } } @if (qrCode || isTotp) {
      <p id="instructions" i18n="Multifactor code prompt on login page">
        {{
          isTotp
            ? 'Enter your sign in code below.'
            : 'Please setup your authenticator application by scanning the QR code and then entering the provided code below.'
        }}
      </p>
      @if (qrCode) {
      <img id="mfa-qr-img-code" src="{{ qrCode }}" />
      }
      <div
        class="input-with-icon"
        [ngClass]="{
                'has-error': !mfaCodeFormControl.valid && mfaCodeFormControl.touched,
              }"
      >
        <!-- prettier-ignore -->
        <input
          id="mfacode-input"
          type="text"
          class="form-control"
          placeholder="Enter Code"
          autocomplete="off"
          i18n-placeholder="Placeholder text for multifactor code field on login page"
          [formControl]="mfaCodeFormControl"
          autofocus
        />
        <app-error-display [control]="mfaCodeFormControl"></app-error-display>
      </div>
      @if (!requestInFlight) {
      <button class="submit-login btn" type="submit" (click)="attemptVerify()">
        <div
          class="submit-label"
          i18n="Label for submit login information button"
        >
          Submit
        </div>
        <span class="icon icon-right">
          <i class="fa fa-arrow-right"></i>
        </span>
      </button>
      } @if (requestInFlight) {
      <div class="login-spinner">
        <app-spinner></app-spinner>
      </div>
      } }
    </form>
  </div>
  } @if (ssoScreen) {
  <div id="login-form-and-help">
    <div id="login-form">
      <p id="instructions" i18n="Password prompt on login page">
        Logging in through SSO for client {{ clientId }}
      </p>
      @if (!ssoError) {
      <div class="login-spinner">
        <app-spinner></app-spinner>
      </div>
      } @if (ssoError) {
      <div class="login-spinner">
        {{ ssoError }}
      </div>
      }
    </div>
  </div>
  }

  <div id="welcome-text" i18n="Welcome text for login prompt">
    Welcome to CX builder<span>&trade;</span>
  </div>
  } @else {
  <ng-container></ng-container>
  }
</div>
